import React from "react";
import { Link } from "react-router-dom";

function Breadcrumb({ breadcrumbs, isLoading = false }) {
  return (
    <>
      {!isLoading && (
        <div className="breadcrumb">
          <ul>
            {/* {breadcrumbs?.map((item, index) => {
              return item.link && !item.active ? (
                <li key={index}>
                  <Link to={item.link}>{item.title}</Link>
                </li>
              ) : (
                <li key={index} className={item.active ? " active" : ""}>
                  <span>{item.title}</span>
                </li>
              );
            })} */}

            {breadcrumbs?.map((item, index) => {
              return item.link ? (
                <li key={index}>
                  <Link to={item.link === "/" ? item.link:`/catalog/${item.link}`}>{item.label.charAt(0).toUpperCase() + item.label.slice(1).toLowerCase()}</Link>
                </li>
              ) : (
                <li key={index}>
                  {item.label.charAt(0).toUpperCase() + item.label.slice(1).toLowerCase()}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
}

export default Breadcrumb;
